import { render, staticRenderFns } from "./store-list.vue?vue&type=template&id=65e1d330&scoped=true&"
import script from "./store-list.vue?vue&type=script&lang=js&"
export * from "./store-list.vue?vue&type=script&lang=js&"
import style0 from "./store-list.vue?vue&type=style&index=0&id=65e1d330&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e1d330",
  null
  
)

export default component.exports